import { useQuery } from "@tanstack/react-query";
import type { UserInfo } from "types/user";

import { queryKeys } from "../queryKeys";
import * as userService from "./userService";

export function useMe(enabled: boolean) {
  return useQuery<UserInfo>({
    queryKey: queryKeys.me,
    queryFn: userService.getMe,
    staleTime: 5 * 60_000,
    enabled,
    retry: 18,
    retryDelay: 10_000,
  });
}
